import { render, staticRenderFns } from "./AccountSettingGeneral.vue?vue&type=template&id=1ffad5cc&scoped=true&"
import script from "./AccountSettingGeneral.vue?vue&type=script&lang=js&"
export * from "./AccountSettingGeneral.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingGeneral.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AccountSettingGeneral.vue?vue&type=style&index=1&id=1ffad5cc&lang=scss&scoped=true&"
import style2 from "./AccountSettingGeneral.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffad5cc",
  null
  
)

export default component.exports